import React from "react";
import { MotionConfig } from "framer-motion";
import { SalesPage } from "./pages/SalesPage";
import { useMetaPixel } from "./hooks/useMetaPixel";
export function App() {
  useMetaPixel("1822734912085445");
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3k8jeh6phyiiu">
      <SalesPage data-id="element-1" data-mp="3k78ezj333wxj" />
    </MotionConfig>;
}